import { createAjaxEpic } from '../utils';
import { fetchPlace, fetchPlaces, postReviews } from './actions';

const fetchPlaceUrlCreator = (params) => `/api/places/${params.id}`;
const fetchPlaceEpic = createAjaxEpic(fetchPlaceUrlCreator, fetchPlace);
const fetchPlacesEpic = createAjaxEpic('/api/places/', fetchPlaces);

const postReviewsUrl = (params) => `/api/places/${params.id}/reviews`;
const postReviewsComplete = postReviews.complete;
postReviews.complete = [(payload, initialPayload) => postReviewsComplete(initialPayload)] as any;
const postReviewsEpic = createAjaxEpic(postReviewsUrl, postReviews, 'post');

export { fetchPlaceEpic, fetchPlacesEpic, postReviewsEpic };



// WEBPACK FOOTER //
// ./src/app/models/Places/epics.ts